import { GetExperiment } from '@moonpig/web-core-eppo/server'
import { graphQlExperimentsWhitelist } from './graphQlExperimentsWhitelist'
import { mockWhitelist } from './mockGraphQLExperimentsWhitelist'

export const buildExperimentsHeader = (
  getEppoExperimentString: GetExperiment,
  getContentfulExperimentNames: () => string[],
  canSendExperimentToServer: (experimentKey: string) => boolean = () => true,
  currentDate: Date = new Date(),
): string => {
  const USE_MOCK_GRAPHQL_EXPERIMENTS = process.env.USE_MOCK_GRAPHQL_EXPERIMENTS
  const activeExperiments = (
    USE_MOCK_GRAPHQL_EXPERIMENTS === 'true'
      ? mockWhitelist
      : graphQlExperimentsWhitelist
  )
    .filter(experiment =>
      experiment.expiry ? experiment.expiry >= currentDate : true,
    )
    .map(({ key, logGlobally }) => ({
      key,
      logGlobally,
    }))

  const contentfulExperiments = getContentfulExperimentNames().map(key => ({
    key,
    logGlobally: true,
  }))

  activeExperiments.push(...contentfulExperiments)

  const headerParts = activeExperiments
    .filter(({ key }) => canSendExperimentToServer(key))
    .map(({ key, logGlobally }) => {
      const variant = getEppoExperimentString(key, {
        fallback: 'fallback',
        subjectAttributes: {
          shouldLog: logGlobally ?? false,
        },
      })

      return `${key}=${variant}`
    })

  return headerParts.sort().join(';')
}
